import { Injectable } from "@angular/core";
import countries from "i18n-iso-countries";

import en from "i18n-iso-countries/langs/en.json";
import fr from "i18n-iso-countries/langs/fr.json";

@Injectable({
  providedIn: "root",
})
export class CountryService {
  private registered = new Set<string>();

  constructor() {
    this.registerLocale("en", en);
    this.registerLocale("fr", fr);
  }

  private registerLocale(locale: string, data: any): void {
    if (!this.registered.has(locale)) {
      countries.registerLocale(data);
      this.registered.add(locale);
    }
  }

  getCountries(locale: string): { code: string; name: string }[] {
    return Object.entries(countries.getNames(locale))
      .map(([code, name]) => ({ code, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }
}
